import React, { memo } from 'react';
import { ProductoCard, Producto } from './ProductoCard';
type Props = {
  id: string;
  variant: 'origen' | 'memoria' | 'pausa';
  numero: string;
  nombre: string;
  descripcion: string;
  productos: Producto[];
  testimonio: {
    quote: string;
    autor: string;
  };
};
export function Coleccion({
  id,
  variant,
  numero,
  nombre,
  descripcion,
  productos
}: Props) {
  return <section className={`coleccion coleccion--${variant}`} id={id} data-id="element-72">
      <div className="savia-container" data-id="element-73">
        <div className="coleccion__header" data-id="element-74">
          <div className="reveal-left" data-id="element-75">
            <p className="coleccion__numero" data-id="element-76">{numero}</p>
            <h2 className="coleccion__nombre" data-id="element-77">{nombre}</h2>
          </div>
          <p className="coleccion__descripcion reveal-right" data-id="element-78">{descripcion}</p>
        </div>
        <div className="coleccion__grid" data-id="element-79">
          {productos.map((p, i) => <ProductoCard key={p.nombre} producto={p} delay={i + 1} data-id="element-80" />)}
        </div>
      </div>
    </section>;
}